import { render, staticRenderFns } from "./cadplanodetreino.vue?vue&type=template&id=483f0e0b&"
import script from "./cadplanodetreino.vue?vue&type=script&lang=js&"
export * from "./cadplanodetreino.vue?vue&type=script&lang=js&"
import style0 from "./cadplanodetreino.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports